import { Routes, Route } from "react-router-dom";
import { NotFound } from "../components/common";
import Home from "../pages/Assessment/Home";
import Detail from "../pages/Assessment/Detail";
import Edit from "../pages/Assessment/Edit";

const Assessment = () => {
  return (
    <div className="Assessment">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/:id" element={<Detail />} />
        <Route path="/:id/edit" element={<Edit />} />
        <Route path="/*" element={<NotFound />} />
      </Routes>
    </div>
  );
};

export default Assessment;
